import { useMemo } from 'react';

import { useCurrentOrPrevUser } from '@lib/hooks';
import { RolloutEnum } from '@lib/resources/types';

import useCurrentWidgetUser from './useCurrentWidgetUser';

export default function useHasAccessToRollout(rollout: RolloutEnum) {
  const user = useCurrentOrPrevUser();
  const widgetUser = useCurrentWidgetUser();

  const rollouts = user?.rollouts || widgetUser?.rollouts;

  const hasAccessToRollout = useMemo(() => !!rollouts?.includes(rollout), [rollouts, rollout]);

  return hasAccessToRollout;
}
